export const setBlogPosts = (state, blogPosts) => {
  state.blogPosts = blogPosts
}
